import { getPartnerViewIdsForGroups, getSiteIdsForGroups } from "@/utils/store";
const DEFAULT_STATE = {
  // Filter states
  partnerViewGroups: [],
  partnerViews: [],
  siteGroups: [],
  sites: [],
  threshold: 30, // Default value for % de baisse
};

const getters = {
  // Filter getters
  getPartnerViewGroups: (state) => state.partnerViewGroups,
  getPartnerViews: (state) => state.partnerViews,
  getSiteGroups: (state) => state.siteGroups,
  getSites: (state) => state.sites,
  getThreshold: (state) => state.threshold,
};

const mutations = {
  INIT_STATE(state) {
    for (const [key, value] of Object.entries(DEFAULT_STATE)) {
      state[key] = value;
    }
  },
  // Filter mutations
  SET_PARTNER_VIEW_GROUPS(state, groups) {
    state.partnerViewGroups = groups;
  },
  SET_PARTNER_VIEWS(state, views) {
    state.partnerViews = views;
  },
  SET_SITE_GROUPS(state, groups) {
    state.siteGroups = groups;
  },
  SET_SITES(state, sites) {
    state.sites = sites;
  },
  SET_THRESHOLD(state, threshold) {
    state.threshold = threshold;
  },
};

const actions = {
  initState({ commit }) {
    commit("INIT_STATE");
  },
  // Filter actions
  async updatePartnerViewGroups({ commit }, groups) {
    commit("SET_PARTNER_VIEW_GROUPS", groups);

    if (!groups || !groups.length) {
      commit("SET_PARTNER_VIEWS", []);
      return;
    }

    try {
      const partnerViewIds = await getPartnerViewIdsForGroups(groups);
      commit("SET_PARTNER_VIEWS", partnerViewIds);
      return partnerViewIds;
    } catch (error) {
      console.error("Error fetching partner views for groups:", error);
      commit("SET_PARTNER_VIEWS", []);
    }
  },

  updatePartnerViews({ commit }, views) {
    commit("SET_PARTNER_VIEWS", views);
  },

  async updateSiteGroups({ commit }, groups) {
    commit("SET_SITE_GROUPS", groups);

    if (!groups || !groups.length) {
      commit("SET_SITES", []);
      return;
    }

    try {
      const siteIds = await getSiteIdsForGroups(groups);
      commit("SET_SITES", siteIds);
      return siteIds;
    } catch (error) {
      console.error("Error fetching sites for groups:", error);
      commit("SET_SITES", []);
    }
  },

  updateSites({ commit }, sites) {
    commit("SET_SITES", sites);
  },

  updateThreshold({ commit }, threshold) {
    commit("SET_THRESHOLD", threshold);
  },

  clearFilters({ commit }) {
    commit("SET_PARTNER_VIEW_GROUPS", []);
    commit("SET_PARTNER_VIEWS", []);
    commit("SET_SITE_GROUPS", []);
    commit("SET_SITES", []);
    commit("SET_THRESHOLD", 30); // Reset to default value
  },
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters,
  mutations,
  actions,
};
